import { useEffect } from 'react';

declare global {
  interface Window {
    kindlyChat?: {
      openChat: () => void;
    };
  }
}

function appendKindlyScript(botKey: string, language: string) {
  let script = document.getElementById(
    'kindly-chat'
  ) as HTMLScriptElement | null;
  if (script) {
    return script;
  }

  script = document.createElement('script');
  script.id = 'kindly-chat';
  script.src = 'https://chat.kindlycdn.com/kindly-chat.js';
  script.dataset.botKey = botKey;
  script.dataset.language = language;
  script.dataset.shadowDom = 'true';
  script.defer = true;

  document.body.appendChild(script);
  return script;
}

export const useKindlyChat = (botKey: string, language = 'en') => {
  useEffect(() => {
    if (!botKey) {
      return;
    }

    appendKindlyScript(botKey, language);

    const handleKindlyLoad = () => {
      if (!window.kindlyChat?.openChat) {
        //biome-ignore lint/suspicious/noConsole: log error
        console.error('Kindly chat is not available');
        return;
      }

      const openChat = () => window.kindlyChat?.openChat();

      const triggerButton = document.getElementById('kindly-bot-trigger-chat');
      const startChatCardTrigger = document.getElementById(
        'start-chat-card-trigger'
      );

      triggerButton?.addEventListener('click', openChat);
      startChatCardTrigger?.addEventListener('click', openChat);
    };

    document.addEventListener('kindly:load', handleKindlyLoad);

    return () => {
      document.removeEventListener('kindly:load', handleKindlyLoad);
    };
  }, [botKey, language]);
};
